import React from 'react';
import { Link } from 'react-router';

import { cn } from '@/lib/utils';

type StyledLinkProps = {
  href: string;
  className?: string;
  children?: React.ReactNode;
} & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>;

const isExternal = (href: string) =>
  /^(https?:|mailto:|tel:|#)/.test(href);

export const StyledLink = ({
  className,
  children,
  href,
  ...rest
}: StyledLinkProps) => {
  const styles = cn('text-primary hover:text-primary/75', className);
  if (isExternal(href)) {
    return (
      <a className={styles} href={href} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <Link className={styles} to={href} {...rest}>
      {children}
    </Link>
  );
};
